/**
 * @file src/components/atoms/ImageIcon/ImageIcon.tsx
 * @description This component renders an image within an icon-like container. It optionally accepts custom width and height values.
 * @module ImageIcon
 */

import React, { FC } from 'react';
import Image from 'next/image';
import { icon } from '@/components/atoms/Icon/Icon';
import { VariantProps } from 'class-variance-authority';

interface ImageIconProps extends VariantProps<typeof icon> {
  imageSrc: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
}

const ImageIcon: FC<ImageIconProps> = ({
  imageSrc,
  alt,
  className,
  size = 'md',
  intent = 'primary',
  width,
  height,
}) => {
  const iconClassName = !width && !height ? icon({ size, intent }) : '';
  const customStyle =
    width && height ? { width: `${width}px`, height: `${height}px` } : {};

  return (
    <div
      className={`${iconClassName} ${className} relative`}
      style={customStyle}
    >
      <Image
        src={imageSrc}
        alt={alt}
        fill
        style={{ objectFit: 'contain' }}
        className="absolute inset-0"
      />
    </div>
  );
};

export default ImageIcon;
